import React from "react";
import CustomMultipleResourcePage from "../components/CustomMultipleResourcePage";
import { Container } from "@amzn/awsui-components-react";

const ReconciliationPage = ({selectedCPView, viewAccess, addOrEditAccess, resetHref}) => (
  <Container>
    <CustomMultipleResourcePage
      pageType="ACCOUNT RECONCILIATION"
      tabType="LIST"
      owner={selectedCPView}
      viewAccess={viewAccess}
      addOrEditAccess={addOrEditAccess}
      resetHref={resetHref}
    />
  </Container>
);

export default ReconciliationPage;
